import {
  GET_PROVINCE_LIST,
  GET_PROVINCE_LIST_FAILED,
  GET_PROVINCE_LIST_SUCCESS,

  GET_DISTRICT_LIST,
  GET_DISTRICT_LIST_FAILED,
  GET_DISTRICT_LIST_SUCCESS,

  GET_WARD_LIST,
  GET_WARD_LIST_FAILED,
  GET_WARD_LIST_SUCCESS,
} from './actionTypes';

export const actionGetProvinceList = (payload) => ({
  payload,
  type: GET_PROVINCE_LIST,
});

export const actionGetProvinceListSuccess = (payload) => ({
  payload,
  type: GET_PROVINCE_LIST_SUCCESS,
});

export const actionGetProvinceListFailed = (payload) => ({
  payload,
  type: GET_PROVINCE_LIST_FAILED,
});

export const actionGetDistrictList = (payload) => ({
  payload,
  type: GET_DISTRICT_LIST,
});

export const actionGetDistrictListSuccess = (payload) => ({
  payload,
  type: GET_DISTRICT_LIST_SUCCESS,
});

export const actionGetDistrictListFailed = (payload) => ({
  payload,
  type: GET_DISTRICT_LIST_FAILED,
});

export const actionGetWardList = (payload) => ({
  payload,
  type: GET_WARD_LIST,
});

export const actionGetWardListSuccess = (payload) => ({
  payload,
  type: GET_WARD_LIST_SUCCESS,
});

export const actionGetWardListFailed = (payload) => ({
  payload,
  type: GET_WARD_LIST_FAILED,
});
